import allImgPaths from "assets/images";
import DonutChart from "components/common/charts/DonutChart";
import PinModal from "components/common/modal/PinModal";
import useAppState from "context/useAppState";
import { cloneDeep } from "lodash";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { sendEmails } from "services/event";

const BudgetCard = ({ taskId, data: dataObj, deleteItem, editItem, actions, unPinTaskData, callFromBoard }: any) => {
    const [data, setData] = useState(dataObj || null);
    const [budgetData, setBudgetData] = useState(data?.content || [])
    const { id: eventId } = useParams();
    const totalBudgetInit = {
        category: 'Total Budget', key: 'total_budget', value: "", originalValue: 0, placeholder: "30,000", remaining: 0, color: '#D0D5DD'
    }
    const [totalBudget, setTotalBudget] = useState<any>(totalBudgetInit);
    const [totalAllocated, setTotalAllocated] = useState(0)
    const [allocatedPercent, setAllocatedPercent] = useState(0)
    const { eventFetchedData } = useAppState("eventData");

    useEffect(() => {
        const budget = eventFetchedData?.budget?.max;
        if (budget && budget > -1) {
            const updatedTotalBudget = cloneDeep(totalBudget);
            updatedTotalBudget.value = budget > 0 ? formatNumber(budget.toString()) : budget;
            updatedTotalBudget.originalValue = budget;
            setTotalBudget(updatedTotalBudget)
        }

        const previousBudgetValue = dataObj?.totalBudgetValue || budget;
        // const updatedBudgetData = budget >= previousBudgetValue ? data?.content : refreshBudgetValues(budget, data?.content)
        const updatedBudgetData = data?.content

        const totalAllocated = updatedBudgetData.reduce((a: any, b: any) => a + (+b.originalValue || 0), 0)
        setTotalAllocated(totalAllocated)
        setAllocatedPercent((totalAllocated / (budget || 0)) * 100)
        setBudgetData(updatedBudgetData)

        // calculate(budget || 0)
    }, [])

    const refreshBudgetValues = (budget: any, items: any[] = []) => {
        let budgetItems = items;
        budgetItems = budgetItems.map(item => {
            const newOriginalValue = (item.percent / 100) * budget;
            return {
                ...item,
                originalValue: +newOriginalValue,
                value: formatNumber(newOriginalValue.toString())
            };
        });

        console.log({ budgetItems })
        return budgetItems
    }

    const formatNumber = (number: any) => {
        return number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const handleUserImageError = (e: any) => {
        e.target.src = allImgPaths.defaultProfileImage
    }

    const deleteOne = (messageId: any, title: any) => {
        deleteItem({ messageId, taskId }, title)
        setShowOption(false)
    }

    const editOne = (messageId: any, title: any) => {
        editItem({ messageId, taskId }, title)
    }

    const sendEmail = async (ragId: any) => {
        await sendEmails(eventId, { ragId })
    }

    const [showPinModal, setShowPinModal] = useState(false);
    const [showOption, setShowOption] = useState<any>(false);
    const [isPinned, setIsPinned] = useState<boolean>(data?.is_pinned || false)

    const openPinModal = async () => {
        setShowPinModal(true)
    }

    const afterSave = (value: boolean) => {
        if (value) {
            setIsPinned(true)
        }
    }

    const unPinTask = async () => {
        if (callFromBoard) return

        const payload = {
            isPinned: false,
            pinData: null,
            taskTitle: data?.title || ''
        }

        unPinTaskData(data?.ragId, payload)
        setIsPinned(false)
    }

    const unPinTaskFromMenu = async () => {
        const payload = {
            isPinned: false,
            pinData: null,
            taskTitle: data?.title || ''
        }

        unPinTaskData(data?.ragId, payload)
        setData(null)
    }

    return (
        <>
            {
                showPinModal &&
                <PinModal
                    data={data}
                    setShowPinModal={setShowPinModal}
                    afterSave={afterSave}
                />
            }
            {
                data?.content && data?.content?.length &&
                <div className='border border-[#EAECF0] px-2 py-2 rounded-[10px] bg-[#fff] w-[280px] flex-shrink-0 hover:shadow-xl'>
                    <div className="relative">
                        {/* callfromboard Design */}
                        {
                            callFromBoard &&
                            <div className="rounded-tl-lg rounded-tr-lg border border-dashed border-[#EAECF0] pl-4 pt-1">
                                <h5 className="text-lg text-[#344054] truncate max-w-52 font-interMedium">
                                    {data?.pinData?.title || 'No Title'}
                                </h5>
                                <h6 className="text-sm text-[#344054] pb-2 truncate max-w-52">
                                    {data?.pinData?.selectedOption || 'No Subheading'}
                                </h6>
                            </div>
                        }

                        <div className='rounded-[10px] mb-2.5 group'>
                            <div className='flex items-center justify-between '>
                                {!isPinned &&
                                    <div onClick={openPinModal} className={`group-hover:flex hidden items-center gap-x-1.5 bg-[#1E0AF5] hover:bg-[#120693] py-1.5 px-3 rounded-lg text-[#fff] absolute top-2 right-2 cursor-pointer w-fit`}>
                                        <img src={allImgPaths.pinPushIcon} alt="" />
                                        <span>Pin it</span>
                                    </div>
                                }
                                {
                                    isPinned &&
                                    <div className={`absolute top-2 right-2 w-fit pinned-state`}>
                                        <img src={allImgPaths.pinnedStateIcon} alt="" />
                                    </div>
                                }
                            </div>
                            <div className="flex justify-center bg-[#F9FAFB] rounded-[10px] pt-6 pb-2">
                                <DonutChart
                                    showLegends={false}
                                    colors={[totalBudget.color, ...(budgetData?.map((fd: any) => fd.color) || [])]}
                                    series={[(+(totalBudget.originalValue - totalAllocated).toFixed(2) || 0), ...(budgetData?.map((fd: any) => +fd.originalValue) || [])]}
                                    labels={['Remaining', ...(budgetData?.map((fd: any) => fd.category) || [])]}
                                    height="160"
                                    width="160"
                                />

                            </div>
                        </div>
                        <div className="mt-1.5 text-center py-2">
                            <p className="text-lg text-[#101828] font-interSemiBold pb-2.5">Set Budget: ${totalBudget.value}</p>
                            <p className="text-base text-[#475467] pb-2.5">Current Balance</p>
                            <p className="text-4xl text-[#101828] font-interMedium pb-2.5">${(totalBudget.originalValue - totalAllocated).toLocaleString()}</p>
                            <p className="text-base text-[#101828] pb-1.5">${totalAllocated.toLocaleString()} / {allocatedPercent.toFixed(2)}% used</p>
                        </div>
                    </div>
                    {/* <div className='relative px-2 mb-4 max-h-[90px] overflow-y-auto no-css' dangerouslySetInnerHTML={{ __html: data.text.body }}>

                    </div> */}
                    <div className='flex items-center gap-x-2 justify-between border-t border-[#EAECF0] pt-2 pb-1'>
                        <div className='flex items-start gap-x-2'>
                            <img
                                className='w-6 h-6 rounded-full'
                                src={data.userProfileImage || allImgPaths.defaultProfileImage}
                                alt=''
                                onError={(e: any) => handleUserImageError(e)}
                            />
                            <div>
                                <p className='text-xs text-[#667085] pb-0.5'>{data.userName}</p>
                                <p className='text-xs text-[#667085]'>{data.updatedTime}</p>
                            </div>
                        </div>

                        <div className="relative group">
                            <img className={`cursor-pointer mr-1`} src={allImgPaths.threeVerticleDotsIcon} alt="" />

                            <div className={`absolute -right-1 -bottom-[10px] w-[188px] rounded-lg shadow-customShadow9 bg-[#fff] px-2 py-2 z-20 border border-[#eee] group-hover:block hidden`}>
                                {
                                    actions?.showView &&
                                    <div className="flex items-center gap-x-2 my-1.5 cursor-pointer w-fit mb-4 last:mb-0 custom-group-hover">
                                        <img
                                            className='w-5 h-5 group-hover-child'
                                            src={allImgPaths.iButtonIcon}
                                            alt=''
                                        />
                                        <span className="text-[#101828] text-base font-interMedium leading-none group-hover-child-text">
                                            View
                                        </span>
                                    </div>
                                }
                                {
                                    !isPinned && !callFromBoard && actions?.showEdit &&
                                    <div className="flex items-center gap-x-2 my-1.5 cursor-pointer w-fit mb-4 last:mb-0 custom-group-hover" onClick={() => editOne(data?.messageId, data.title)}>
                                        <img
                                            className='w-5 h-5 group-hover-child'
                                            src={allImgPaths.EditIcon2}
                                            alt=''
                                        />
                                        <span className="text-[#101828] text-base font-interMedium leading-none group-hover-child-text">
                                            Edit
                                        </span>
                                    </div>
                                }

                                {
                                    !callFromBoard && actions?.showDelete &&
                                    <div
                                        className="flex items-center gap-x-2 my-1.5 cursor-pointer w-fit mb-4 last:mb-0 custom-group-hover"
                                        onClick={() => deleteOne(data?.messageId, data.title)}>
                                        <img
                                            className='w-5 h-5 group-hover-child'
                                            src={allImgPaths.deleteIcon4}
                                            alt=''
                                        />
                                        <span className="text-[#101828] text-base font-interMedium leading-none group-hover-child-text">
                                            Delete
                                        </span>
                                    </div>
                                }

                                {
                                    actions?.showDownload &&
                                    <div className="flex items-center gap-x-2 my-1.5 cursor-pointer w-fit mb-[22px] last:mb-0 custom-group-hover">
                                        <img
                                            className='w-5 h-5 group-hover-child'
                                            src={allImgPaths.downloadIcon2}
                                            alt=''
                                        />
                                        <span className="text-[#101828] text-base font-interMedium leading-none group-hover-child-text">
                                            Download
                                        </span>
                                    </div>
                                }

                                {
                                    callFromBoard &&
                                    <div
                                        className="flex items-center gap-x-1 my-1.5 cursor-pointer w-fit last:mb-0 custom-group-hover" onClick={unPinTaskFromMenu}>
                                        <img
                                            className='w-5 h-5 group-hover-child'
                                            src={allImgPaths.deleteIcon4}
                                            alt=''
                                        />
                                        <span className="text-[#101828] text-base font-interMedium leading-none pl-1 group-hover-child-text">
                                            Unpin
                                        </span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default BudgetCard;
